import { render, staticRenderFns } from "./PatientProfileSkeleton.vue?vue&type=template&id=3a8fa607&scoped=true"
import script from "./PatientProfileSkeleton.vue?vue&type=script&lang=js"
export * from "./PatientProfileSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PatientProfileSkeleton.vue?vue&type=style&index=0&id=3a8fa607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8fa607",
  null
  
)

export default component.exports